
  import { ReactChart } from 'chartjs-react';
  import { Chart, registerables } from 'chart.js';
  import { useEffect } from 'react';
  import TenantServices from './../../services/TenantServices';
  import { useState } from 'react';
  Chart.register(...registerables);

export default function BillGraph(){
    const [graphData, setGraphData] = useState({});
    const [dataGraph, setAirtimeGraph]= useState({})
    const [utilityGraph, setUtilityGraph] = useState({})
    const [dataOpt, setDataOpt] = useState({
      plugins: {
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 10,
            usePointStyle: true,
            pointStyle: "line"
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          title: {
            display: true,
            text: "Data Payment",
            color: "red",
            font: {
              size: 24,
              weight: "bold"
            }
          }
        },
        y: {
          grid: {
            color: "#ccc",
            borderDash: [5, 1],
            borderColor: "black",
            tickColor: "black"
          },
          title: {
            display: true,
            text: "",
            color: "green",
            font: {
              size: 18,
              weight: "bold"
            }
          }
        }
      }
    });
    const [airtimeOpt, setAirtimeOpt] = useState({
      plugins: {
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 10,
            usePointStyle: true,
            pointStyle: "line"
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          title: {
            display: true,
            text: "Airtime Payment",
            color: "red",
            font: {
              size: 24,
              weight: "bold"
            }
          }
        },
        y: {
          grid: {
            color: "#ccc",
            borderDash: [5, 1],
            borderColor: "black",
            tickColor: "black"
          },
          title: {
            display: true,
            text: "",
            color: "green",
            font: {
              size: 18,
              weight: "bold"
            }
          }
        }
      }
    });
    const [utility, setUtility]= useState({
      plugins: {
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 10,
            usePointStyle: true,
            pointStyle: "line"
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          title: {
            display: true,
            text: "Bills Payment",
            color: "red",
            font: {
              size: 24,
              weight: "bold"
            }
          }
        },
        y: {
          grid: {
            color: "#ccc",
            borderDash: [5, 1],
            borderColor: "black",
            tickColor: "black"
          },
          title: {
            display: true,
            text: "",
            color: "green",
            font: {
              size: 18,
              weight: "bold"
            }
          }
        }
      }
    })

     
    const trnxGraph = async () => {
        var labels = [];
        var SucccessfulUtilityData = [];
        var failedUtilityData = [];
        var successfulAirtime =[];
        var failedAirtime=[];
        var successfulData=[];
        var failedDATA=[];
        const resp = await TenantServices.billsGraph();
        
        resp.data.map(data => {
          SucccessfulUtilityData.push(data.successSum );
          failedUtilityData.push(data.failedSum );
          failedAirtime.push(data.airtimeFailedSum);
          successfulAirtime.push(data.airtimeSuccessSum);
            successfulData.push(data.dataSuccessSum);
            failedDATA.push(data.dataFailedSum)
            labels.push(data.date );
        });
        var airtimeOption = {
          labels: [...labels],
          datasets: [  
            {
              label: "Successful Airtime",
              data: [...successfulAirtime],
              lineTension: 0,
              fill: false,
              borderColor: 'yellow',
              backgroundColor: 'transparent',
              pointBorderColor: 'yellow',
              pointBackgroundColor: 'yellow',
              borderDash: [15, 5],
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 2,
              pointStyle: 'rectRounded'
            },      
          {
            label: "Failed Airtime",
            data: [...failedAirtime],
            lineTension: 0,
            fill: false,
            borderColor: 'purple',
            backgroundColor: 'transparent',
            pointBorderColor: 'purple',
            pointBackgroundColor: 'purple',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          }
         
        ]
        }
        var utilityOption = {
          labels: [...labels],
          datasets: [
            {
            label: "Successful Bills",
            data: [...SucccessfulUtilityData],
            lineTension: 0,
            fill: false,
            borderColor: 'green',
            backgroundColor: 'transparent',
            pointBorderColor: 'green',
            pointBackgroundColor: 'green',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          },
          {
            label: "Failed Bills",
            data: [...failedUtilityData],
            lineTension: 0,
            fill: false,
            borderColor: 'red',
            backgroundColor: 'transparent',
            pointBorderColor: 'red',
            pointBackgroundColor: 'red',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          },
      
       
        ]
        }
        var dataOptions = {
          labels: [...labels],
          datasets: [    
          {
            label: "Successful Data",
            data: [...successfulData],
            lineTension: 0,
            fill: false,
            borderColor: 'gray',
            backgroundColor: 'transparent',
            pointBorderColor: 'gray',
            pointBackgroundColor: 'gray',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          },
          {
            label: "Failed Data",
            data: [...failedDATA],
            lineTension: 0,
            fill: false,
            borderColor: 'orange',
            backgroundColor: 'transparent',
            pointBorderColor: 'orange',
            pointBackgroundColor: 'orange',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          }]
        };
      
      
    setGraphData(dataOptions);
    setAirtimeGraph(airtimeOption)
    setUtilityGraph(utilityOption);

    }

    useEffect(() => {
        trnxGraph();
    }, [])
    return(
        <>
  
    {/* Airtime graph */}
    <div className='mt-5'>
      <ReactChart 
      type='line'
      options={airtimeOpt}
      data={dataGraph}
      width ={100}/>
    </div>
    {/* Other payments */}
    <div className='mt-5'>
      <ReactChart type='line'
      options={utility}
      data={utilityGraph}
      width={100} />
    </div>
          {/* Data graph */}
          <ReactChart
      type="line"
      data={graphData}
      options={dataOpt}
      width={100}
    />
        </>
    )
}